import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody, TablePagination } from "@mui/material";
import UnActiveCarRequestTableRow from "../TableRows/UnActiveCarRequestTableRow";
import UnActiveRequestsTableHead from "../TableHeads/UnActiveRequestsTableHead";
import { handleChangePage, handleChangeRowsPerPage } from "../../../../SharedComponents/utils/helpers/tableHelpers";
import { requestGetUnActiveRequests } from "../../../reduxStore/sagas/requests/userCars";

const UnActiveRequestsTableInAllRequestsPage = ({
    id
}) => {
    const DEFAULT_ROWS_PER_PAGE = 15;

    const [isTableShown, setIsTableShown] = useState(true);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);

    const [fetchedUnActiveCarRequestsData, setFetchedUnActiveCarRequestsData] = useState(null);

    const filterDto = {
        id: id,
        limit: rowsPerPage,
        offset: page * rowsPerPage,
    };

    const [filter, setFilter] = useState(filterDto);


    useEffect(() => {
        setFilter(filterDto);
    }, [page, rowsPerPage]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await requestGetUnActiveRequests(filter);

                if (response) {
                    setFetchedUnActiveCarRequestsData(response.data);
                };

            }
            catch (error) {
                console.error(error);
            };
        };

        fetchData();
    }, [filter]);


    if (!fetchedUnActiveCarRequestsData) {
        return null;
    };


    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Ostali zahtevi"}
                count={fetchedUnActiveCarRequestsData.count}
                open={isTableShown}
                setOpen={setIsTableShown}
            />

            {isTableShown && (
                <div style={styles.tablePaddingDiv}>
                    <div style={styles.tableBorderDiv}>
                        <Table>
                            <UnActiveRequestsTableHead />

                            <TableBody>

                                {fetchedUnActiveCarRequestsData.rows.map((row, index) => (
                                    <UnActiveCarRequestTableRow
                                        key={index}
                                        carRequest={row}
                                    />
                                ))}

                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[15, 25, 50]}
                            component="div"
                            count={fetchedUnActiveCarRequestsData.count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={(event, newPage) => {
                                handleChangePage(event, newPage, setPage)
                            }}
                            onRowsPerPageChange={(event) => {
                                handleChangeRowsPerPage(
                                    event,
                                    setRowsPerPage,
                                    setPage
                                )
                            }}
                        />

                    </div>
                </div>
            )}

        </div>
    );
};


export default UnActiveRequestsTableInAllRequestsPage;

const styles = {
    mainContainer: {

    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    }
};